import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { useCurrentOrg } from '../../data/use_current_org.tsx';
import { Button } from './button.tsx';
import {
  goToNextOnboardingStep,
  Message,
  setOnboardingHouseholdSurveyResponse,
  shareWithMusicLeader,
} from './common.tsx';
import { Frame } from './frame.tsx';

export const ShareMusicLeader = () => {
  const { currentOrg } = useCurrentOrg();
  const navigate = useNavigate();

  const onNextPage = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.ShareMusicLeader, action: 'continue' });
  }, [navigate]);

  const onShare = useCallback(async () => {
    setOnboardingHouseholdSurveyResponse({ sharedWithChurch: true });
    await shareWithMusicLeader();
    await onNextPage();
  }, [onNextPage]);

  const onSkip = useCallback(async () => {
    setOnboardingHouseholdSurveyResponse({ sharedWithChurch: false });
    await onNextPage();
  }, [onNextPage]);

  return (
    <Frame
      onboardingPage={OnboardingPages.ShareMusicLeader}
      mainContent={
        <Message $widthInChars={22}>
          No problem!
          <br />
          <br />
          Get your church set up; Share this with anyone in your {currentOrg?.type?.toLowerCase() ?? 'church'} to start
          the conversation.
        </Message>
      }
      footerContent={
        <>
          <Button onClick={onShare}>SHARE</Button>
          <Button onClick={onSkip}>MAYBE LATER</Button>
        </>
      }
      onEnterKeypress={onShare}
    />
  );
};
